import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { useEffect } from "react";
import { API_BASE_URL } from "../config";
import "../styles/components/CartDrawer.scss";

export default function CartDrawer() {
  const { items, subtotal, drawerOpen, closeCart, updateQty, removeItem, clearCart } = useCart();

  useEffect(() => {
    if (!drawerOpen) return undefined;

    const onKeyDown = (e) => {
      if (e.key === "Escape") closeCart();
    };

    document.addEventListener("keydown", onKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [drawerOpen, closeCart]);

  const imageUrl = (img) =>
  img
    ? `${API_BASE_URL}/images/products/${img}`
    : `${API_BASE_URL}/images/products/default.jpg`;

  return (
    <div
      className={`cart-drawer ${drawerOpen ? "open" : ""}`}
      onClick={closeCart}
      aria-hidden={!drawerOpen}
    >
      <aside
        className="cart-panel"
        role="dialog"
        aria-modal="true"
        aria-label="Shopping cart"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="cart-top">
          <div>
            <div className="cart-title">Your Cart</div>
            <div className="cart-sub">{items.length ? `${items.length} item(s)` : "Empty"}</div>
          </div>
          <button type="button" className="cart-x" aria-label="Close cart" onClick={closeCart}>
            ×
          </button>
        </div>

        <div className="cart-list">
          {items.length === 0 ? (
            <div className="cart-empty">
              <div className="empty-title">Cart is empty</div>
              <div className="empty-sub">Add premium pieces to start your order.</div>
            </div>
          ) : (
            items.map((it) => (
              <div className="cart-item" key={`${it.id}-${it.colorId ?? "none"}`}>
                <img src={imageUrl(it.image)} alt={it.name} />
                <div className="cart-info">
                  <div className="name">{it.name}</div>
                  {it.colorName && (
                    <div className="cart-item-color">
                      <span
                        className="cart-item-color-dot"
                        style={{ backgroundColor: it.colorHex || "#888" }}
                      />
                      {it.colorName}
                    </div>
                  )}

                  <div className="row">
                    <div className="price">${(it.price * it.qty).toFixed(2)}</div>

                    <div className="qty">
                      <button
                        type="button"
                        aria-label={`Decrease quantity of ${it.name}`}
                        onClick={() => updateQty(it.id, it.qty - 1, it.colorId)}
                      >
                        -
                      </button>
                      <span>{it.qty}</span>
                      <button
                        type="button"
                        aria-label={`Increase quantity of ${it.name}`}
                        onClick={() => updateQty(it.id, it.qty + 1, it.colorId)}
                      >
                        +
                      </button>
                    </div>

                    <button
                      type="button"
                      className="rm"
                      aria-label={`Remove ${it.name} from cart`}
                      onClick={() => removeItem(it.id, it.colorId)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        <div className="cart-bottom">
          <div className="totals">
            <span>Subtotal</span>
            <span className="gold">${subtotal.toFixed(2)}</span>
          </div>

          <div className="cart-actions">
            <button className="btn ghost" onClick={clearCart} disabled={!items.length}>
              Clear
            </button>

            <Link
              to="/checkout"
              className={`btn primary ${items.length ? "" : "disabled"}`}
              onClick={items.length ? closeCart : (e) => e.preventDefault()}
            >
              Checkout
            </Link>
          </div>

          <Link to="/cart" className="view" onClick={closeCart}>
            View full cart
          </Link>
        </div>
      </aside>
    </div>
  );
}